/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'instant-message': {
    width: 16,
    height: 16,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M9.167 3a.333.333 0 00-.333.333v5c0 .184.149.334.333.334H15a.5.5 0 01.354.146L17 10.46V3.333A.333.333 0 0016.667 3h-7.5zM18 11.666V3.333C18 2.597 17.403 2 16.667 2h-7.5c-.737 0-1.333.597-1.333 1.333v5c0 .737.596 1.334 1.333 1.334h5.626l2.354 2.353a.497.497 0 00.35.147M18 11.67v-.004.004zm-.038.188A.498.498 0 0018 11.67l-.038.188zm-.27.27a.498.498 0 00.27-.27m-.27.27a.5.5 0 01-.192.039M3.333 8.834A.333.333 0 003 9.167v7.126l1.646-1.646A.5.5 0 015 14.5h5.833c.184 0 .334-.15.334-.333V12.5a.5.5 0 111 0v1.667c0 .736-.597 1.333-1.334 1.333H5.207l-2.353 2.354A.5.5 0 012 17.5V9.167c0-.737.597-1.333 1.333-1.333H5a.5.5 0 110 1H3.333z" _fill="#1F222C"/>'
  }
})
